import React, { useState } from 'react';
import { Form } from 'react-bootstrap';
import Modal from '@rd-web-markets/shared/dist/util/Modal';
import { handleError } from '@rd-web-markets/shared/dist/store/features/alertSlice';
import { useDispatch } from 'react-redux';
import staffProviderService from '../../services/claim/staff_providers.service';
export default function StaffProviderModal(_ref) {
  let {
    claim,
    show,
    onHide,
    onSubmit
  } = _ref;
  const [name, setName] = useState('');
  const dispatch = useDispatch();
  const createStaffProvider = async () => {
    try {
      const staffProvider = await staffProviderService.create(claim.id, {
        name
      });
      onSubmit(staffProvider);
    } catch (error) {
      dispatch(handleError(error));
    }
  };
  const rateModalBody = () => {
    return /*#__PURE__*/React.createElement(Form, null, /*#__PURE__*/React.createElement(Form.Group, null, /*#__PURE__*/React.createElement(Form.Label, {
      className: "col-form-label"
    }, "Name"), /*#__PURE__*/React.createElement(Form.Control, {
      onChange: e => setName(e.target.value),
      rows: 6,
      value: name
    })));
  };
  return /*#__PURE__*/React.createElement(Modal, {
    size: "sm",
    title: "Add Staff Provider",
    show: show,
    renderBody: () => rateModalBody(),
    onHide: () => {
      onHide();
      setName('');
    },
    onSubmit: async () => {
      await createStaffProvider(name);
      setName('');
    }
  });
}